module.exports = __webpack_public_path__ + "img/create-free-account.93d94a81.png";